export class ServeurErreur {
    requestUrl: string;
    exceptionMessage: string;
    erreurId: string;
}